import type { FrontendHealthResponse } from '../types/frontendHealth';
import versionInfo from '../config/version.json';

interface ApiResponse<T = any> {
  ok: boolean;
  status: number;
  data: T;
  error?: string;
}

const frontendHealthService = {
  /**
   * Obtener información de salud del frontend
   */
  getFrontendHealth: async (): Promise<ApiResponse<FrontendHealthResponse>> => {
    try {
      // Simular una pequeña latencia para hacer la verificación más realista
      await new Promise(resolve => setTimeout(resolve, 100));

      const frontendHealth: FrontendHealthResponse = {
        version: versionInfo.version,
        buildDate: versionInfo.buildDate,
        lastDeployment: versionInfo.lastDeployment,
        recentChanges: versionInfo.recentChanges,
        environment: versionInfo.environment,
        timestamp: new Date().toISOString(),
        status: 'UP',
        message: 'Frontend funcionando correctamente'
      };

      return {
        ok: true,
        status: 200,
        data: frontendHealth
      };
    } catch (error) {
      console.error('Error getting frontend health:', error);
      return {
        ok: false,
        status: 500,
        data: {} as FrontendHealthResponse,
        error: error instanceof Error ? error.message : 'Error al obtener información del frontend'
      };
    }
  },

  /**
   * Verificar si hay una nueva versión disponible
   */
  checkForUpdates: async (): Promise<ApiResponse<{ hasUpdate: boolean; latestVersion?: string }>> => {
    try {
      // Aquí podrías hacer una llamada a tu API para verificar si hay una nueva versión
      // Por ahora, simulamos que no hay actualizaciones
      return {
        ok: true,
        status: 200,
        data: {
          hasUpdate: false,
          latestVersion: versionInfo.version
        }
      };
    } catch (error) {
      console.error('Error checking for updates:', error);
      return {
        ok: false,
        status: 500,
        data: { hasUpdate: false },
        error: error instanceof Error ? error.message : 'Error al verificar actualizaciones'
      };
    }
  }
};

export { frontendHealthService };
